require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/src/app/vendor/lib-typedarrays.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./src/app/vendor/lib-typedarrays.js
 ** module id = 21
 ** module chunks = 0
 **/